import Link from "next/link";
import SOCIAL from "@/data/social.json";

const FOOTER_ORDER = [
  "GitHub",
  "Linkedin",
  "Malt",
] as const;

type SocialEntry = (typeof SOCIAL)[number];

export default function Footer() {
  const links = FOOTER_ORDER.map((name) =>
    SOCIAL.find((s) => s.name === name)
  ).filter((e): e is SocialEntry => Boolean(e));

  return (
    <footer className="bg-background w-full py-6 md:py-12 border-t border-white/15">
      <div className="flex flex-col md:flex-row justify-between items-center px-12 md:pl-32 gap-6">
        <div className="font-['Inter'] text-[10px] tracking-[0.2em] uppercase text-white/70">
          {"<"}Benjamin Drouin {"©"}2026{"/>"}
        </div>
        <div className="flex flex-col items-center gap-4 md:items-end">
        <nav
          aria-label="Navigation du pied de page"
          className="flex flex-wrap justify-center gap-x-6 gap-y-2 items-center text-[10px] tracking-[0.2em] uppercase text-white/70 md:justify-end"
        >
          <Link href="/" className="hover:text-white transition-colors">
            Accueil
          </Link>
          <Link href="/a-propos" className="hover:text-white transition-colors">
            À propos
          </Link>
          <Link href="/projets" className="hover:text-white transition-colors">
            Projets
          </Link>
          <Link href="/blog" className="hover:text-white transition-colors">
            Blog
          </Link>
          <Link href="/contact" className="hover:text-white transition-colors">
            Contact
          </Link>
        </nav>
        <div className="flex flex-wrap justify-center gap-x-8 gap-y-2 items-center md:justify-end">
          {links.map((entry) => (
            <a
              key={entry.name}
              className="font-['Inter'] text-[10px] tracking-[0.2em] uppercase text-white/70 hover:text-white transition-colors"
              href={entry.url}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={entry.name}
            >
              {"footerShort" in entry && entry.footerShort
                ? entry.footerShort
                : entry.name.toUpperCase()}
            </a>
          ))}
          <Link
            href="/mentions-legales"
            className="font-['Inter'] text-[10px] tracking-[0.2em] uppercase text-white/70 hover:text-white transition-colors"
          >
            Mentions légales
          </Link>
        </div>
        </div>
      </div>
    </footer>
  );
}
